// import server_config from '../../server_config'

export const CORE_API_ENDPOINT =  `/api/`
// `/api`
// `/depa`
// `http://localhost:2000`
// `https://backoffice.rmdtac.com/core`
// `https://backoffice.rmdtac-uat2.com/core`
// `https://backoffice.dtacbainisys.com/core`
// `http://10.0.30.9:8807/depa/`
// export const PREFIX = `/backend`


// export const CORE_API_ENDPOINT = `https://www.rmbainisys.com/depa`
export const PREFIX = ''


// WEBPACK FOOTER //
// ./src/lib/api.js